// extracted by mini-css-extract-plugin
export default {"wrap":"gE-z","fullWidth":"hE-z","hideOnDesktop":"iE-z","content":"jE-z","hasOpenedNav":"kE-z","crumbsList":"lE-z","dropdownsWrap":"mE-z"};